var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.5C22 5.88071 20.8807 7 19.5 7C19.0664 7 18.6585 6.88959 18.303 6.69535L14.8528 9.65271C14.9481 9.91729 15 10.2026 15 10.5C15 11.8807 13.8807 13 12.5 13C11.1193 13 10 11.8807 10 10.5C10 10.3677 10.0103 10.2379 10.0301 10.1111L7.08871 8.43038C6.65678 8.78626 6.10335 9 5.5 9C4.11929 9 3 7.88071 3 6.5C3 5.11929 4.11929 4 5.5 4C6.88071 4 8 5.11929 8 6.5C8 6.63223 7.98973 6.76206 7.96996 6.88874L10.9114 8.56955C11.3433 8.21371 11.8967 8 12.5 8C12.9336 8 13.3415 8.1104 13.6969 8.30462L17.1472 5.34725C17.0519 5.08268 17 4.7974 17 4.5C17 3.11929 18.1193 2 19.5 2C20.8807 2 22 3.11929 22 4.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.1838C17 9.53002 17.53 9 18.1838 9H20.8162C21.47 9 22 9.53002 22 10.1838V20.8162C22 21.47 21.47 22 20.8162 22H18.1838C17.53 22 17 21.47 17 20.8162V10.1838Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18382 11C3.53002 11 3 11.53 3 12.1838V20.8162C3 21.47 3.53002 22 4.18382 22H6.81618C7.46998 22 8 21.47 8 20.8162V12.1838C8 11.53 7.46998 11 6.81618 11H4.18382Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1838 15C10.53 15 10 15.53 10 16.1838V20.8162C10 21.47 10.53 22 11.1838 22H13.8162C14.47 22 15 21.47 15 20.8162V16.1838C15 15.53 14.47 15 13.8162 15H11.1838Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsAlt1);
export default __webpack_public_path__ + "static/media/analytics-alt-1.ff5f20583ec47518ea6714425b5b3c51.svg";
export { ForwardRef as ReactComponent };